import { Navigate } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';
import { canAny } from '@/utils/permissions';
import { LoadingPage } from '@/components/ui/loading-page';

interface PermissionRouteProps {
  permissions: string[];
  children: React.ReactNode;
}

export const PermissionRoute = ({ permissions: requiredPaths, children }: PermissionRouteProps) => {
  const { permissions, adminType, loading } = usePermissions();
  
  if (loading) {
    return <LoadingPage message="Checking permissions..." />;
  }
  
  if (!canAny(permissions, requiredPaths, adminType)) {
    return <Navigate to="/forbidden" replace />;
  }
  
  return <>{children}</>;
};

